import { useCallback } from "react";
import { Outlet } from "react-router-dom";

import { PaymentMethodFormsProvider } from "../contexts/payment-method-form-context";

export const PaymentMethodLayout = () => {
  const handleSubmit = useCallback((values: Record<string, string>) => {
    console.log("Final form submission:", values);
  }, []);

  return (
    <PaymentMethodFormsProvider onSubmit={handleSubmit}>
      <Outlet />
    </PaymentMethodFormsProvider>
  );
};
